

























































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import Confirm from '@/modules/common/dialog/components/shared/Confirm.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop, PropSync } from 'vue-property-decorator'
import { PaymentLink, StartPaymentResource } from '@/modules/transaction/models/payment.model'

@Component({
  components: { BaseButton, Confirm }
})
export default class PaymentGatewayConfirm extends Vue {

  @PropSync('gatewayConfirmData', { default: false }) gatewayConfirm!: boolean
  @Prop({ default: '' }) paymentLinkUrl!: string
  @Prop() startPayment!: StartPaymentResource
  @Prop() paymentLink!: PaymentLink


}
